import AnamnesisView, { Views as ANAMNESIS_VIEWS } from 'components/organisms/Anamnesis';
import { calculateBmi } from 'helper/bmi';
import i18n from 'helper/i18n';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, Dispatch } from 'redux';
import {
	actionCreators,
	getAge,
	getGender,
	getIsUpdatingAnamnesis,
	getSuggestedWeightReduceGoal,
	getTempHealthGoal,
	getWeightReduceGoal,
	getWeightReduceMax,
	getWeightReduceMin,
} from 'store/profile';
import { IRootState } from 'store/rootReducer';
import { WithRouterType } from 'types/withRouter';
import { mapParentStateToProps } from '../Anamnesis';

export const GOALS = [
	{
		text: i18n('react.impulsCoach.components.HealthGoal.loseWeightCaption'),
		name: 'fruits' as 'fruits',
	},
	{
		text: i18n('react.impulsCoach.components.HealthGoal.gettingFitCaption'),
		name: 'running' as 'running',
	},
	{
		text: i18n('react.impulsCoach.components.HealthGoal.healthyLifestyleCaption'),
		name: 'healthier' as 'healthier',
	},
];

const mapStateToProps = (state: IRootState, props: WithRouterType) => {
	const parentProps = mapParentStateToProps(state, props);
	const bmiValue = calculateBmi(
		parentProps.weight === null ? undefined : parentProps.weight,
		parentProps.size === null ? undefined : parentProps.size,
		true,
		true
	);
	const tempHealthGoal = getTempHealthGoal(state);

	return {
		...parentProps,
		currentStep: ANAMNESIS_VIEWS.ACCEPT_HEALTH_TARGET,
		isUpdatingAnamnesis: getIsUpdatingAnamnesis(state),
		introTitle: i18n('react.impulsCoach.components.anamnesis.acceptHealthTarget.introTitle'),
		introText: i18n('react.impulsCoach.components.anamnesis.acceptHealthTarget.introText'),
		title: i18n(`react.impulsCoach.components.anamnesis.acceptHealthTarget.title.${tempHealthGoal}`),
		tempHealthGoal,
		bmiValue,
		age: getAge(state),
		gender: getGender(state),
		reduceWeightTarget: {
			recommendedReduceWeight: getSuggestedWeightReduceGoal(state),
			reduceGoal: getWeightReduceGoal(state),
			recommendedStart: getWeightReduceMin(state),
			recommendedEnd: getWeightReduceMax(state),
		},
		goals: GOALS,
	};
};

const mapDispatchToProps = (dispatch: Dispatch) => {
	return bindActionCreators(actionCreators, dispatch);
};

export type AcceptHealthTargetContainerProps = ReturnType<typeof mapStateToProps> &
	ReturnType<typeof mapDispatchToProps>;

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AnamnesisView) as any);
